import {Injectable} from '@angular/core';

@Injectable()
export class StorageService {
  sessionStoragePrefix = 'cpui-sessionStorage-';
  localStoragePrefix = 'cpui-localStorage-';

  constructor() {
  }

  getStore(isLocal: boolean = false) {
    return isLocal ? localStorage : sessionStorage;
  }

  getStorageKeyName(storageKey: string, isLocal: boolean = false) {
    return isLocal ? this.localStoragePrefix + storageKey : this.sessionStoragePrefix + storageKey;
  }

  getStrippedStorageKeyName(storageKey: string) {
    const strippedStorageKey = storageKey.replace(this.sessionStoragePrefix, '')
      .replace(this.localStoragePrefix, '');

    return strippedStorageKey;
  }

  getStorageKeyValue(storageKey: string, isLocal: boolean = false) {
    const store = this.getStore(isLocal), prefixedStorageKey = this.getStorageKeyName(storageKey, isLocal);
    const keyValueStr = store.getItem(prefixedStorageKey);
    const keyValue = this.isKeyValueString(keyValueStr) ? JSON.parse(keyValueStr) : null;
    console.log('CPUI - StorageService.getStorageKeyValue(): ' + prefixedStorageKey, keyValue);

    return keyValue;
  }

  setStorageKeyValue(storageKey: string, storageKeyValue: any, isLocal: boolean = false) {
    const store = this.getStore(isLocal), prefixedStorageKey = this.getStorageKeyName(storageKey, isLocal);
    const keyValueStr = (storageKeyValue) ? JSON.stringify(storageKeyValue) : null;

    if (this.isKeyValueString(keyValueStr)) {
      store.setItem(prefixedStorageKey, keyValueStr);
    } else {
      this.deleteStorageKeyValue(storageKey);
    }
    console.log('CPUI - StorageService.setStorageKeyValue(): ' + prefixedStorageKey, keyValueStr);
  }

  deleteStorageKeyValue(storageKey: string, isLocal: boolean = false) {
    const store = this.getStore(isLocal), prefixedStorageKey = this.getStorageKeyName(storageKey, isLocal);
    store.removeItem(prefixedStorageKey);
    console.log('CPUI - StorageService.deleteStorageKeyValue(): ' + prefixedStorageKey, store.getItem(storageKey));
  }

  clearAllSessionStorageKeys() {
    for (const storageKey in sessionStorage) {
      if (storageKey.startsWith(this.sessionStoragePrefix)) {
        const strippedStorageKey = this.getStrippedStorageKeyName(storageKey);
        console.log('CPUI - StorageService.clearAllSessionStorageKeys() clearing: ' + strippedStorageKey);
        this.deleteStorageKeyValue(strippedStorageKey);
      }
    }
  }

  clearAllLocalStorageKeys() {
    for (const storageKey in localStorage) {
      if (storageKey.startsWith(this.localStoragePrefix)) {
        const strippedStorageKey = this.getStrippedStorageKeyName(storageKey);
        console.log('CPUI - StorageService.clearAllLocalStorageKeys() clearing: ' + strippedStorageKey);
        this.deleteStorageKeyValue(strippedStorageKey);
      }
    }
  }

  clearAllStorage() {
    sessionStorage.clear();
    localStorage.clear();
  }

  isKeyValueString(keyValueStr) {
    return (keyValueStr && (typeof keyValueStr === 'string' || keyValueStr instanceof String));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/storage/storage.service.ts